/**
 * @ngdoc directives
 * @memberof mercury.modules.time
 * @name timecontrol
 */
angular.module('mercury.modules.time.roster')
.directive('timecontrol', function() {
  return {
    restrict: 'A',
    link: function() {

      function setTimeRangeElem(shiftRow) {
        row = shiftRow;
        timeFrom = (row.find('.time-from').val());
        timeTo = (row.find('.time-to').val());
        seperator = '-';
        timeRange = timeFrom + ' ' + seperator + ' ' + timeTo;
        row.find('.time-range').val(timeRange).change();
      }

      jQuery.datetimepicker.setDateFormatter('moment');

      var datePickerOptions = {
        datepicker: false,
        format: 'HH:mm',
        formatTime: 'HH:mm',
        step: 15,
        validateOnBlur: false,
        onChangeDateTime: function(ct, $i) {
          setTimeRangeElem($i.parents('.time-group'));
        }
      };

      jQuery('.time').datetimepicker(datePickerOptions);

      function quickCheckAndAppend(element) {
        var l = element.val().length;
        num = element.val();

        if (l == 1) {
          if (num == 1 || num == 2) {
            element.val(num + '0:00');
          } else {
            element.val('0' + num + ':00');
          }
        } else if (l == 2) {
          if (num >= 24) {
            element.val('00:00');
          } else {
            element.val(num + ':00');
          }
        }
      }

      function setController(e, timeControl) {

        var timeControls = jQuery('.xdsoft_datetimepicker');
        var chosenTimeControl;

        timeControls.each(function(index, element) {
          if (jQuery(element).css('display') == 'block') {
            chosenTimeControl = element;
          }
        });

        timeRail = jQuery(chosenTimeControl).find('.xdsoft_time_variant');

        //get number of rows
        timeRailRows = jQuery(timeRail).find('.xdsoft_time ');
        rows = jQuery(timeRail).find('.xdsoft_time ').length;

        //get the over all height
        h = timeRail.height();

        //get the rowhieht
        rowHeight = h / rows;

        //get the number of steps per hour
        step = 24 / rows;

        var l = jQuery(timeControl).val().length;
        curVal = jQuery(timeControl).val();
        num = parseInt(String.fromCharCode(e.keyCode));

        switch (l) {
          //Get the value length of time control
          //either 1 or two digits long
          case 1:
            if (num == 1) {
              //if 1 digit and the number pushed is 1, then jump to 10 in the time picker
              mTop = (10 * (1 / step)) * rowHeight + 1;
              i = (10 * (1 / step));
            } else if (num == 2) {
              //if 1 digit and the number pushed is 2, then jump to 20 in the time picker
              mTop = (20 * (1 / step)) * rowHeight + 1;
              i = (20 * (1 / step));
            } else {
              // Else, treat as 0 being pushed & prepend, unluss 0 was pushed, then leave the zero off.
              mTop = (num * (1 / step)) * rowHeight + 1;
              i = (num * (1 / step));
              if (num > 0) { jQuery(timeControl).val('0' + num); }
            }
            railMarginTop = mTop;
            timeRailRows.each(function() { jQuery(this).removeClass('xdsoft_current'); });
            jQuery(timeRailRows[i]).addClass('xdsoft_current');
            timeRail.css('margin-top', '-' + railMarginTop + 'px');
          break;

          case 2:

            if (curVal.toString().substring(0, 1) == 1) {
              mTop = ((num + 10) * (1 / step)) * rowHeight + 1;
              i = ((num + 10) * (1 / step));
            } else if (curVal.substring(0, 1) == 2) {
              mTop = ((num + 20) * (1 / step)) * rowHeight + 1;
              i = ((num + 20) * (1 / step));
            } else {
              mTop = (num * (1 / step)) * rowHeight + 1;
              i = (num * (1 / step));
            }

            railMarginTop = mTop;
            timeRailRows.each(function() { jQuery(this).removeClass('xdsoft_current'); });
            jQuery(timeRailRows[i]).addClass('xdsoft_current');
            timeRail.css('margin-top', '-' + railMarginTop + 'px');
            jQuery(timeControl).val(curVal);

          break;
        }

      }
      jQuery(document).on('keydown', '.time', function(e) {

        if (jQuery.inArray(e.keyCode, [46, 8, 27, 13, 110]) !== -1 ||
        // Allow: Ctrl+A, Command+A
        (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: home, end, left, right, down, up
        (e.keyCode >= 35 && e.keyCode <= 40)) {
          // let it happen, don't do anything
          return;
        } else if (e.keyCode == 9) {
          // If tab key press, check number of chars & add appropriate figs.
          quickCheckAndAppend(jQuery(this));
          return;
        }
        // Ensure that it is a number and stop the keypress
        if (!((e.shiftKey && e.keyCode == 186) || (e.keyCode >= 48 && e.keyCode <= 57))) {
          e.preventDefault();
        }

        //is textbox the end time & is it clean?
      });

      jQuery(document).on('focus', '.time', function() {
        jQuery(this).select();
      });

      jQuery(document).on('blur', '.time', function() {
        quickCheckAndAppend(jQuery(this));
        setTimeRangeElem($(this).parents('.time-group'));
      });

      jQuery(document).on('keyup', '.time', function(e) {

        if (jQuery.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
        // Allow: Ctrl+A, Command+A
        (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: home, end, left, right, down, up
        (e.keyCode >= 35 && e.keyCode <= 40)) {
          // let it happen, don't do anything
          return;
        }
        // Ensure that it is a number and stop the keypress
        if (!((e.shiftKey && e.keyCode == 186) || (e.keyCode >= 48 && e.keyCode <= 57))) {
          e.preventDefault();
        } else {
          setController(e, jQuery(this));
        }

      });

    }
  };
});
